import { Model } from './model';

export enum DunningStateAction {
  OUTREACH_PAUSE = 'outreach_pause',
  OUTREACH_ENABLE = 'outreach_enable',
}

export class DunningState extends Model {
  id: string;
  name: string;
  description: string;
  action: DunningStateAction;
  is_dispute_default: boolean = false;
}
